<!-- Encabezado: mismo layout que route-optimization-suggestion.dialog.html (ícono + título a la izquierda, cerrar a la derecha). -->
<div class="flex flex-wrap items-start justify-between gap-3 border-b border-slate-100 px-6 py-4">
  <div class="flex items-center gap-3">
    <span class="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-indigo-500/10 to-violet-500/10">
      <mat-icon class="icon-size-5 text-indigo-500" svgIcon="heroicons_outline:list-bullet"></mat-icon>
    </span>
    <div>
      <div class="text-base font-bold text-slate-900">Orden de visita del viaje</div>
      <div class="text-secondary text-xs" *ngIf="trip">Viaje #{{ trip.id }}</div>
    </div>
  </div>
  <button mat-icon-button (click)="close()" aria-label="Cerrar">
    <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
  </button>
</div>

<mat-dialog-content class="flex flex-col gap-6 !px-6 !py-5">
  <div *ngIf="loading" class="flex h-full items-center justify-center py-16">
    <mat-spinner diameter="36"></mat-spinner>
  </div>

  <ng-container *ngIf="!loading">
    <!-- Datos del viaje: resueltos frescos por tripMongoId, nunca del element de trip-table. -->
    <section
      class="mb-4 flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-slate-100 bg-white p-4 shadow-sm">
      <div class="flex flex-wrap items-center gap-x-8 gap-y-2 text-sm">
        <div>
          <div class="text-secondary text-xs">Ruta</div>
          <div class="font-bold text-slate-900">{{ trip?.subRoute?.name || '—' }}</div>
        </div>
        <div>
          <div class="text-secondary text-xs">Fecha teórica</div>
          <div class="f-10 font-bold text-slate-900">
            FI: <i>{{ trip?.dateHourStartTeoric | FormatDateHour: false }}</i><br>
            FF: <i>{{ trip?.dateHourEndTeoric | FormatDateHour: false }}</i>
          </div>
        </div>
        <div>
          <div class="text-secondary text-xs">Fecha real</div>
          <div class="f-10 font-bold text-slate-900">
            FI: <i>{{ trip?.dateHourStart | FormatDateHour: false }}</i><br>
            FF: <i>{{ trip?.dateHourEnd | FormatDateHour: false }}</i>
          </div>
        </div>
        <div>
          <div class="text-secondary text-xs">Vehículo</div>
          <div class="font-bold text-slate-900">{{ trip?.vehicle?.name || '—' }}</div>
        </div>
        <div>
          <div class="text-secondary text-xs">Responsable</div>
          <div class="font-bold text-slate-900">{{ trip?.user?.user_login?.username || '—' }}</div>
        </div>
        <div>
          <div class="text-secondary text-xs">Estado</div>
          <app-trip-status-badge [statusTripId]="trip?.statusTripId"></app-trip-status-badge>
        </div>
      </div>

      <!-- Toggle de visitOrderMode: independiente del contenido del orden guardado abajo. -->
      <div class="flex items-center gap-2">
        <mat-slide-toggle
          [checked]="trip?.visitOrderMode === visitOrderModeEnum.TRIP"
          [disabled]="savingMode"
          (change)="onVisitOrderModeToggle($event.checked)"
          matTooltip="Orden por subruta (por defecto) vs. orden propio del viaje">
        </mat-slide-toggle>
        <span class="text-secondary text-xs">{{ visitOrderModeLabel }}</span>
      </div>
    </section>

    <!-- Estado vacío: sin prc-trip-visit-order guardado, sin creación manual en esta versión. -->
    <div
      *ngIf="!hasVisitOrder"
      class="flex flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-slate-200 bg-slate-50 py-16 text-center">
      <mat-icon svgIcon="heroicons_outline:map" class="text-slate-300"></mat-icon>
      <p class="text-secondary text-sm">Aún no se ha optimizado el orden de los socios para este viaje.</p>
    </div>

    <!-- Lista arrastrable: Angular CDK Drag & Drop, mismo patrón que route-itinerary.component.ts. -->
    <div
      *ngIf="hasVisitOrder"
      cdkDropList
      [cdkDropListData]="rows"
      (cdkDropListDropped)="drop($event)"
      class="flex flex-col gap-2">
      <div
        *ngFor="let row of rows; let i = index"
        cdkDrag
        class="flex cursor-move items-center gap-3 rounded-2xl border border-slate-100 bg-white p-3 shadow-sm transition-shadow hover:shadow-md">
        <mat-icon svgIcon="heroicons_outline:bars-3" class="text-slate-300"></mat-icon>
        <span
          class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-slate-100 text-xs font-bold text-slate-600">
          {{ i + 1 }}
        </span>
        <div class="min-w-0 flex-1">
          <div class="truncate text-sm font-bold text-slate-900">{{ row.businessPartnerName }}</div>
          <div
            class="truncate text-xs"
            [class.text-secondary]="row.addressFound"
            [class.text-rose-500]="!row.addressFound">
            {{ row.addressLabel }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2 border-t border-slate-100 pt-3">
  <button mat-stroked-button (click)="close()">Cerrar</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!hasVisitOrder || saving || loading"
    (click)="save()">
    <mat-spinner *ngIf="saving" diameter="18" class="mr-2 inline-block"></mat-spinner>
    <mat-icon *ngIf="!saving" svgIcon="heroicons_outline:check-circle"></mat-icon>
    Guardar orden
  </button>
</mat-dialog-actions>
